import { localeTagFor, type Lang } from "@/i18n/locale";
import { PREMIUM_OFFER_PLAN_ID, PREMIUM_PLANS } from "@/config/pricing";

export type LandingMarket = "BR" | "EU";
export const LANDING_MARKET_STORAGE_KEY = "vyv_landing_market_v1";
export const APP_STORE_URL = "https://apps.apple.com/app/id6767212330";

// EUR is the monthly iOS retail price verified in the NL, IE and DE App Store
// on 2026-10-16. It is a separate offer, never an FX conversion of the BRL
// Asaas price. The store confirms the customer's final price and currency.
export const LANDING_OFFERS = {
  BR: { currency: "BRL", monthly: PREMIUM_PLANS[PREMIUM_OFFER_PLAN_ID].value, channel: "web" },
  EU: { currency: "EUR", monthly: 9.99, channel: "app-store" },
} as const;

export function defaultLandingMarket(lang: Lang): LandingMarket {
  // Language supplies only the initial suggestion; visitors can choose either
  // market without changing the language or granting location access.
  return localeTagFor(lang).endsWith("-BR") ? "BR" : "EU";
}

export function readLandingMarket(): LandingMarket | null {
  try {
    const value = window.localStorage.getItem(LANDING_MARKET_STORAGE_KEY);
    return value === "BR" || value === "EU" ? value : null;
  } catch {
    return null; // Storage is optional in private/restricted browsers.
  }
}

export function saveLandingMarket(market: LandingMarket): void {
  try {
    window.localStorage.setItem(LANDING_MARKET_STORAGE_KEY, market);
  } catch {
    // The current selection still works when browser storage is unavailable.
  }
}

export function formatLandingPrice(market: LandingMarket, lang: Lang, free = false): string {
  return new Intl.NumberFormat(localeTagFor(lang), {
    style: "currency",
    currency: LANDING_OFFERS[market].currency,
  }).format(free ? 0 : LANDING_OFFERS[market].monthly);
}
